export const BatchStatus = {
    Planned: 0,
    Preparing: 1,
    Prepared: 2,
    Parceling: 3,
    Parceled: 4,
    Paused: 31
}

export const OrderStatus = {
    "0": "icon-gepland",
    "1": "icon-wordt-bereid",
    "2": "icon-klaar-voor-inpakken",
    "3": "icon-wordt-nu-ingepakt",
    "4": "icon-ingepakt"
}

export const ErrorStatus = {
    "Message": "0",
    "Warning": "1",
    "Error": "2"
}

export const ShowOn = {
    "KitchenPlanning": 0,
    "Reciept": 1,
    "Both": 2
}

